"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnText = exports.warnBorder = exports.warn = exports.success = exports.errorDark = exports.error = exports.borderActive = exports.border = exports.greyAltLighter = exports.greyAlt = exports.grey = exports.black = exports.tertiary = exports.secondaryContrast = exports.secondary = exports.primaryContrast = exports.primaryDark = exports.primary = void 0;
var primary = '#5828c5';
exports.primary = primary;
var primaryDark = '#4821A5';
exports.primaryDark = primaryDark;
var primaryContrast = '#fff';
exports.primaryContrast = primaryContrast;
var secondary = '#00DB96';
exports.secondary = secondary;
var secondaryContrast = '#fff';
exports.secondaryContrast = secondaryContrast;
var tertiary = '#1dc1e7';
exports.tertiary = tertiary;
var black = '#1c2226';
exports.black = black;
var grey = '#e9f1f1';
exports.grey = grey;
var greyAlt = '#767676';
exports.greyAlt = greyAlt;
var greyAltLighter = '#BEA8A7';
exports.greyAltLighter = greyAltLighter;
var border = 'rgba(0, 0, 0, 0.23)';
exports.border = border;
var borderActive = '#5828c5';
exports.borderActive = borderActive;
var error = '#d32f2f';
exports.error = error;
var errorDark = '#710627';
exports.errorDark = errorDark;
var success = '#43a047';
exports.success = success;
var warn = '#fff3cd';
exports.warn = warn;
var warnBorder = '#ffeeba';
exports.warnBorder = warnBorder;
var warnText = '#856404';
exports.warnText = warnText;